import { render, staticRenderFns } from "./DisasterRecovery.vue?vue&type=template&id=ed4183a8&scoped=true&"
import script from "./DisasterRecovery.vue?vue&type=script&lang=js&"
export * from "./DisasterRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4183a8",
  null
  
)

export default component.exports